export default __webpack_public_path__ + "static/media/DALogo.fa06183d.png";